import 'bootstrap/dist/css/bootstrap.min.css';
import '../sass/_bootstrap.scss';

import { createApp } from 'vue';
import router from './router';
import '@mdi/font/css/materialdesignicons.css';
import VueGoogleMaps from '@fawmi/vue-google-maps';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { faCircle as faCircleRegular } from '@fortawesome/free-regular-svg-icons';

import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';

library.add(fas);
library.add(faCircleRegular);

const app = createApp({});
app.use(router);
app.component('fa', FontAwesomeIcon);
app.component('faLayer', FontAwesomeLayers);
app.component('faLayerText', FontAwesomeLayersText);
app.use(VueGoogleMaps, {
  load: {
    v: 3.55,
    loading: 'async',
    key: (window as any).Laravel.mix.GOOGLE_API_KEY,
  },
});

app.mount('#app');

// app.config.errorHandler = (err, vm, info) => {
//   let errorMessage = 'エラーが発生しました。トップページに移動しますか？\n\n';
//   errorMessage += '[エラー内容]\n' + err + '\n';
//   errorMessage += '[Info]\n' + info + '\n';
//   if (confirm(errorMessage)) {
//     location.href = '/';
//   }
// };
